// src/api/inventory/inventoryAdjustmentQueryApi.ts
import apiHandler from "../core/apiHandler";

const inventoryAdjustmentQueryApi = apiHandler("inventory/adjustments/query");

export default inventoryAdjustmentQueryApi;
